import './SourcePageCopyDialog.scss';
import React from 'react';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { useGetSourcePageCopy } from '../../../../../shared/api/hooks/monitor/data/sources/UseGetSourcePageCopy';

interface SourcePageCopyDialogProps {
  visible: boolean;
  onHide: () => void;
  projectId: number | null;
  source: string;
}

/**
 * The stored copy of the cited page, as text. Rendered as a text node only — never as HTML — the copy is
 * a third party's page and the stored markup must not reach the DOM.
 */
const SourcePageCopyDialog: React.FC<SourcePageCopyDialogProps> = ({ visible, onHide, projectId, source }) => {
  const { t } = useTranslation();
  const { pageCopy, isLoading, isError } = useGetSourcePageCopy(projectId, source, visible);

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={t('savedPageCopy')}
      className="dialog-box source-page-copy-dialog"
      style={{ width: '760px' }}
    >
      <div className="source-page-copy-dialog__content">
        <span className="source-page-copy-dialog__url text-ellipsis">{source}</span>
        <p className="source-page-copy-dialog__note">{t('savedPageCopyDevNote')}</p>
        {isLoading && <p className="source-page-copy-dialog__note">{t('loadingDataPleaseWait')}</p>}
        {!isLoading && (isError || !pageCopy) && (
          <p className="source-page-copy-dialog__note">{t('savedPageCopyMissing')}</p>
        )}
        {!isLoading && pageCopy && (
          <>
            <p className="source-page-copy-dialog__note">
              {t('savedPageCopyFrom', { date: format(new Date(pageCopy.fetchedAt), 'dd.MM.yyyy HH:mm') })}
              {pageCopy.truncated && ` ${t('savedPageCopyTruncated')}`}
            </p>
            <pre className="source-page-copy-dialog__text">{pageCopy.text}</pre>
          </>
        )}
      </div>
    </Dialog>
  );
};

export default SourcePageCopyDialog;
